import { ANALYTICS_OPERATION_DATA, ANALYTICS_BIKES_DATA, ANALYTICS_MEMBERS_DATA } from '@/libs/fakeData'
import i18n from '@/i18n'

const state = {
  selects: [
    {
      name: 'city',
      multiple: true,
      label: i18n.t('activity.selects.city.label'),
      placeholder: i18n.t('activity.selects.city.placeholder'),
      items: [
        { header: '台北市' },
        { text: '中正區', value: '中正區' },
        { text: '中山區', value: '中山區' },
        { divider: true },
        { header: '新北市' },
        { text: '板橋區', value: '板橋區' },
        { text: '中和區', value: '中和區' },
        { divider: true },
        { header: '桃園市' },
        { text: '桃園區', value: '桃園區' },
        { text: '中壢區', value: '中壢區' }
      ]
    },
    {
      name: 'station',
      multiple: true,
      label: i18n.t('activity.selects.station.label'),
      placeholder: i18n.t('activity.selects.station.placeholder'),
      items: [
        { header: '中正區' },
        { text: '站點A', value: '站點A' },
        { text: '站點b', value: '站點b' },
        { divider: true },
        { header: '板橋區' },
        { text: '站點c', value: '站點c' },
        { text: '站點d', value: '站點d' },
        { divider: true },
        { header: '桃園區' },
        { text: '站點e', value: '站點e' },
        { text: '站點f', value: '站點f' }
      ]
    },
    {
      name: 'duration',
      multiple: false,
      label: i18n.t('activity.selects.duration.label'),
      placeholder: i18n.t('activity.selects.duration.placeholder'),
      items: [
        { text: '當日', value: '當日' },
        { text: '當週', value: '當週' },
        { text: '當月', value: '當月' },
        { text: '今年', value: '今年' },
        { text: '自訂區間', value: '自訂區間' }
      ]
    }
  ],
  datasOptions: [
    { text: '銷售分析', value: 'operation' },
    { text: '車輛分析', value: 'bikes' },
    { text: '會員', value: 'members' }
  ],
  target: 'operation'
}

const getters = {
  selects ({ selects }) {
    return selects
  },
  target ({ target }) {
    return target
  },
  datasOptions ({ datasOptions }) {
    return datasOptions
  },
  currentData ({ target }) {
    const DATAS = {
      operation: ANALYTICS_OPERATION_DATA,
      bikes: ANALYTICS_BIKES_DATA,
      members: ANALYTICS_MEMBERS_DATA
    }

    return DATAS[target]
  }
}

const actions = {
  setTarget ({ commit }, value) {
    commit('SET_TARGET', value)
  }
}

const mutations = {
  SET_TARGET (state, value) {
    state.target = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
